module.exports = __webpack_public_path__ + "static/media/logo-full.2424d788.svg";